import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as MermaPartService from "../../../../services/MermaPartService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import moment from "moment-timezone";

import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./mermaPartList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { useMermaPart } from "../hook/useMermaPart";
import { converToTime } from "../../../../utils/formats/number";
import { PART_STATUS } from "../../../../constants/index";

const MermaPartListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const refresh = () => {
    setForceRefresh(true);
  };
  const { createPart, updatePart } = useMermaPart(refresh);

  const getColumns = () => {
    const columns = [];
    columns.push({
      header: t("forms.mermaPart.table.heads.date"),
      accessorKey: "initTime",
      cell: (info) => moment(info.getValue()).format("DD-MM-yyyy"),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.taskTime"),
      accessorKey: "taskTime",
      cell: (info) => (info.getValue() ? converToTime(info.getValue()) : "-"),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.item"),
      accessorKey: "code.article.code",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.batch"),
      accessorKey: "code.batch.code",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.numPlants"),
      accessorKey: "numPlants",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.variety"),
      accessorKey: "code.variety.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.location"),
      accessorKey: "code.location.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.sector"),
      accessorKey: "code.sector.name",
      cell: (info) => {
        if (info.row.original.code.sector) {
          return info.getValue();
        }
        return "-";
      },
    });
    columns.push({
      header: t("forms.mermaPart.table.heads.vivero"),
      accessorKey: "vivero.name",
      cell: (info) => info.getValue(),
    });
    columns.push({
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    });

    return columns;
  };

  // const goToEdit = (uuid) => {
  //   navigate(`/user/workingPart/form/update/${uuid}`);
  // };

  // const showPart = (uuid) => {
  //   if () {
  //     navigate(`/technical/workingPart/detail/${uuid}`);
  //   } else {
  //     navigate(`/user/workingPart/detail/${uuid}`);
  //   }
  // };

  const handlerPartUpdate = async (partUuid) => {
    await updatePart(partUuid);
  };

  const renderAction = (data) => {
    return (
      <div className="d-flex justify-content-center">
        <div className="text-center">
          <ButtonAction
            onClick={() => showDialogOnDelete(data.uuid)}
            type="button"
            $isDelete
          >
            <i className="fa-solid fa-trash-can"></i>
          </ButtonAction>
        </div>
        <div className="text-center">
          <ButtonAction
            onClick={() => handlerPartUpdate(data.uuid)}
            type="button"
          >
            <i className="fa-solid fa-file-pen"></i>
          </ButtonAction>
        </div>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      MermaPartService.deleteMermaPart(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.mermaPart.dialog.remove.title"),
      t("forms.mermaPart.dialog.remove.text"),
      "warning",
      true,
      t("forms.mermaPart.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.mermaPart.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const goToForm = async () => {
    createPart();
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-initTime";
    }
    const result = await MermaPartService.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={getColumns()}
        toList={listData}
        hideColum={hideColumn}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-secondary btn-md"
            onClick={() => goToForm()}
          >
            {t("forms.mermaPart.buttons.new")}
          </button>
        </div>
      </div>
    </>
  );
};

MermaPartListContainer.propTypes = {
  filters: PropTypes.object,
};

export default MermaPartListContainer;
